<template>
	<!-- 个人信息 -->
	<div class="pad-2 wid-12" v-show="!$route.meta.showFather">
		<div class="box-shadow flex-1  pad-1">
			<div style="padding-right: 98px;">
				<div class="flex-1 mb-25 " style="">
					<p class="name1">用户头像</p>
					<div class="pic">
						<img v-if="imageUrl" :src="imageUrl?''+imageUrl:'@/assets/avatar.gif'" class="imgs-1" />
						<img :src="userInfo.avatar" alt="" class="imgs-1" v-else>
					</div>
					<el-upload class="avatar-uploader" :action="imgBaseUrl +'/infra/file/upload'
" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<!-- 跨域访问后端的路径，action一定要加api；否则跨域访问会失败，然后就报错。 -->
						<img src="../../assets/myself/genghuan.png" alt="" class="imgs-2">
						<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div> -->
					</el-upload>
				</div>
				<div class="flex-1 mb-12 jus-bet">
					<p class="name1">昵称</p>
					<el-input v-model="userInfo.nickname" placeholder="请输入内容"></el-input>
				</div>
				<div class="flex-1 mb-12 jus-bet">
					<p class="name1">联系方式</p>
					<div class="xiugai">
						<el-input v-model="userInfo.mobile" placeholder="请输入内容"></el-input>
						<p class="update" @click="update">修改电话</p>
					</div>
				</div>
				<!-- <div class="flex-1 jus-bet" v-show="yzmShow">
                    <p class="name1">验证码</p>
                    <el-input v-model="userInfo.num" placeholder="请输入验证码"></el-input>
                </div> -->
			</div>
			<div>
				<div class="flex-1 mb-12 jus-bet">
					<p class="name1">姓名</p>
					<el-input v-model="userInfo.name" placeholder="请输入您的姓名"></el-input>
				</div>
				<div class="flex-1 mb-12 jus-bet">
					<p class="name1">地域</p>
					<el-cascader size="large" :placeholder="cascaderText" :options="options1" v-model="selectedOptions"
						@change="handleChange" v-if="selectedOptions.length">
					</el-cascader>
					<!-- <el-cascader v-model="value" :options="options1" @change="handleChange"></el-cascader> -->

					<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
				</div>
				<div class="flex-1 mb-12 jus-bet">
					<p class="name1">单位</p>
					<el-input v-model="userInfo.workUnit" placeholder="请输入您的单位名称"></el-input>
				</div>
				<div class="flex-1 mb-12 jus-bet">
					<p class="name1">单位性质</p>
					<el-select v-model="userInfo.workTypeId" placeholder="请选择您的单位性质">
						<el-option v-for="item in workTypes" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
				</div>
				<div class="flex-1 jus-bet">
					<p class="name1">职务</p>
					<el-input v-model="userInfo.duties" placeholder="请输入您的职务名称"></el-input>
				</div>
			</div>
		</div>
		<div class="flex-1" style="justify-content: space-between;margin-top: 48px;">
			<div></div>
			<el-button type="primary" @click="save">保存</el-button>
			<div></div>
		</div>

		<el-dialog :visible.sync="accountShow" width="600px" :show-close="false" :close-on-click-modal="false" center>
			<div>
				<img src="../../../src/assets/expert/close.png" alt="" @click="accountShow = false" class="close-icon">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
					<div>
						<el-form-item prop="mobile">
							<div class="inp-text">
								<img src="../../../src/assets/phone.png" alt="" class="inp-text-icon" />
								<el-input class="no-border" placeholder="请输入手机号" v-model="ruleForm.mobile"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="code">
							<div class="inp-text">
								<img src="../../../src/assets/cipher.png" alt="" class="inp-text-icon" />
								<el-input class="no-border" placeholder="请输入验证码" v-model="ruleForm.code"></el-input>
								<div class="code-btn" v-if="stus" @click="setCode">点击获取</div>
								<div class="code-btn" v-if="!stus">{{sunmax}}s后获取</div>
							</div>
						</el-form-item>
						<el-form-item>
							<el-button class="pop-btn" type="primary" @click="setCodeLogin">确认修改</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		instance
	} from '@/utils/request.js';
	import {
		regionData,
		CodeToText
	} from 'element-china-area-data';
	import {
		getTypes
	} from '@/api/expert/api.js';
	import {
		getUpdateUser,
		getUpdateMobile,
		getUser,
		updateUserMobile,
		sendSmsCode
	} from '@/api/api.js';

	export default {
		data() {
			return {
				stus: true,
				sunmax: 60,
				accountShow: false,
				input: '',
				imageUrl: '',
				value: '',
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				ruleForm: {
					name: '',
					code: '',
				},
				rules: {
					mobile: [{
						required: true,
						message: '请填写手机号码',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请填写验证码',
						trigger: 'blur'
					}],
				},
				options1: regionData,
				userInfo: {
					areaCode: '',
					cityCode: '',
					provinceCode: '',
					provinceName: '',
					cityName: '',
					areaName: '',
					nickname: '',
					name: '',
					workUnit: '',
					mobile: '',
					workTypeId: '',
					avatar: '',
					duties: '',
					code: '',
				},
				selectedOptions: [],
				workTypes: [],
				imgBaseUrl: 'https://www.zgjyzjw.com/beishida/app-api',
				cascaderText: '',
				// yzmShow: false
			}
		},
		created() {
			this.userInfo = this.$store.state.activity.user;
			let provinceCode = this.userInfo.provinceCode ? this.userInfo.provinceCode.toString() : null;
			let cityCode = this.userInfo.cityCode ? this.userInfo.cityCode.toString() : null;
			let areaCode = this.userInfo.areaCode ? this.userInfo.areaCode.toString() : null;
			this.selectedOptions[0] = provinceCode;
			this.selectedOptions[1] = cityCode;
			this.selectedOptions[2] = areaCode;
			this.getUserData();

		},
		mounted() {
			this.getDwxz()
		},
		methods: {
			setCode() {
				sendSmsCode({
					mobile: this.ruleForm.mobile,
					scene: 2,
				}).then(res => {
					if (res.code == 0) {
						this.stus = false;
						let timeInt = setInterval(() => {
							this.sunmax--;
							if (this.sunmax <= 0) {
								this.stus = true;
								this.sunmax = 60;
								clearInterval(timeInt);
							}
						}, 1000);
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			setCodeLogin() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						updateUserMobile({
							mobile: this.ruleForm.mobile,
							code: this.ruleForm.code,
						}).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '修改成功！',
									type: 'success'
								});
								this.getUserData();
								this.accountShow = false;
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getUserData() {
				this.selectedOptions = [];
				getUser().then(res => {
					if (res.code == 0) {
						this.selectedOptions[0] = res.data.provinceCode + '';
						this.selectedOptions[1] = res.data.cityCode + '';
						this.selectedOptions[2] = res.data.areaCode + '';
						if (res.data.provinceName && res.data.cityName && res.data.areaName) {
							this.cascaderText = res.data.provinceName + '/' + res.data.cityName + '/' + res.data
								.areaName;
						} else {
							this.cascaderText = '请选择地域';
						}
						this.userInfo = res.data ? res.data : this.userInfo;
					}
				})
			},
			getDwxz() {
				getTypes({
					type: 5
				}).then(res => {
					let arr = [];
					let list = res.data;
					list.forEach((item, index) => {
						arr.push({
							id: item.id,
							name: item.name,
						})
					})
					this.workTypes = arr;
				})
			},
			handleChange(selectedOptions) {
				// this.userInfo.provinceCode = value[0];
				// this.userInfo.cityCode = value[1];
				// this.userInfo.areaCode = value[2];
				const [provinceCode, cityCode, areaCode] = selectedOptions;
				// console.log(selectedOptions, 'selectedOptions')
				let area = this.getCodeToText([provinceCode, cityCode, areaCode].join(','), [provinceCode, cityCode,
					areaCode
				])
				const areaArray = area.split('/');
				this.userInfo.provinceCode = provinceCode;
				this.userInfo.cityCode = cityCode;
				this.userInfo.areaCode = areaCode;
				this.userInfo.provinceName = areaArray[0];
				this.userInfo.cityName = areaArray[1],
					this.userInfo.areaName = areaArray[2];
				// console.log(areaArray, 'areaArray')
				// this.selectedOptions = areaArray;
				// console.log(this.userInfo.provinceCode,'this.userInfo.provinceCode')
			},
			getCodeToText(codeStr, codeArray) {
				if (null === codeStr && null === codeArray) {
					return null;
				} else if (null === codeArray) {
					codeArray = codeStr.split(",");
				}
				let area = "";
				switch (codeArray.length) {
					case 1:
						area += CodeToText[codeArray[0]];
						break;
					case 2:
						area += CodeToText[codeArray[0]] + "/" + CodeToText[codeArray[1]];
						break;
					case 3:
						area +=
							CodeToText[codeArray[0]] +
							"/" +
							CodeToText[codeArray[1]] +
							"/" +
							CodeToText[codeArray[2]];
						break;
					default:
						break;
				}
				return area;
			},

			handleAvatarSuccess(res, file) {
				console.log(res, file)
				this.userInfo.avatar = res.data;
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			updatePhone(e) {
				console.log(e.target.value, '---e')
				let value = e.target.value;
				let reg = /^1[3456789]\d{9}$/;
				if (reg.test(value)) {
					this.userInfo.mobile = value;
					this.xiuPhone(this.userInfo.mobile);
					return true;
				} else {
					// console.log('不合法');
					this.$message.warning('手机格式不正确');
					return false;
				}

			},
			update() {
				// this.userInfo.mobile = '';
				this.accountShow = true;
			},
			xiuPhone(mobile) {
				let params = {
					mobile: mobile
				}
				getUpdateMobile(
					params
				).then(res => {
					if (res.code == 0) {
						// this.userInfo.mobile = '';
						this.$message.success('修改成功');
					}

				})
			},
			save() {
				// console.log(this.userInfo, 'ruleForm')
				let params = {
					areaCode: this.userInfo.areaCode,
					cityCode: this.userInfo.cityCode,
					provinceCode: this.userInfo.provinceCode,
					areaName: this.userInfo.areaName,
					cityName: this.userInfo.cityName,
					provinceName: this.userInfo.provinceName,
					nickname: this.userInfo.nickname,
					name: this.userInfo.name,
					workTypeId: this.userInfo.workTypeId,
					avatar: this.userInfo.avatar,
					duties: this.userInfo.duties,
					code: this.userInfo.code,
					workUnit: this.userInfo.workUnit,
					mobile: this.userInfo.mobile,
					address: this.userInfo.provinceName + this.userInfo.cityName + this.userInfo.areaName,
				}
				getUpdateUser(
					params
				).then(res => {
					if (res.code == 0) {
						this.$message.success('保存成功')
						// this.$router.go(0);
					}

				})
			}
		},

	}
</script>

<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-1 {
		padding: 32px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;

	}

	.jus-bet {
		justify-content: end;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
		margin-right: 10px;
	}

	.record {
		font-size: 14px;
		color: #333333;
		line-height: 21px;
		font-family: font3;
		margin-right: 8px;
	}

	.record-1 {
		font-size: 20px;
		color: #222222;
		font-family: font5;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.vipp div p:first-child,
	.tishi {
		font-family: font3;
		color: #666666;
		font-size: 14px;
		margin-bottom: 8px;
	}

	.vipp div p:last-child,
	.hui {
		font-family: font5;
		color: #222222;
		font-size: 16px;
	}

	.unPhoto {
		/* width: 100%;height: auto; */
	}

	.tishi {
		color: #FF4E33 !important;
	}

	/deep/.el-input {
		width: 300px;
	}

	.name1 {
		/* width:84px; */
		white-space: nowrap;
		color: #222222;
		line-height: 22px;
		font-size: 14px;
		font-family: font3;
		padding-right: 16px;
	}

	.mb-12 {
		margin-bottom: 12px;
	}

	.mb-25 {
		margin-bottom: 25px;
	}

	.imgs-1 {
		width: 66px;
		height: 66px;
		margin-right: 1rem;
		border-radius: 50%;
	}

	.imgs-2 {
		width: 112px;
		height: 30px;
	}

	.xiugai {
		position: relative;
	}

	.update {
		position: absolute;
		top: 25%;
		right: 5%;
		color: #3377FF;
		cursor: pointer;
		font-size: 14px;
		font-family: font3;
	}

	.el-button--primary {
		background-color: #3377FF;
		color: #ffffff;
		font-family: font3;
		font-size: 1rem;
		/* width: 9.5%; */
		text-align: center;
		white-space: nowrap;
	}

	/deep/.el-form-item__label {
		/* margin-top: 5%; */
		white-space: nowrap;
		color: #222222;
		line-height: 22px;
		font-size: 14px;
		font-family: font3;
		padding-right: 16px;
	}

	.inp-text {
		width: 360px;
		height: 56px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EFEFEF;
		display: flex;
		align-items: center;
	}

	.inp-text-icon {
		width: 24px;
		height: 24px;
		margin-left: 20px;
	}

	/deep/ .no-border .el-input__inner {
		border: none !important;
		box-shadow: none !important;
	}

	.code-btn {
		width: 100px;
		font-weight: normal;
		font-size: 14px;
		color: #3377FF;
	}

	.pop-btn {
		width: 360px;
		height: 46px;
	}

	.close-icon {
		position: absolute;
		right: 30px;
		top: 30px;
	}
</style>